import { render, staticRenderFns } from "./warehouseShelves.vue?vue&type=template&id=65cc0f61&scoped=true&"
import script from "./warehouseShelves.vue?vue&type=script&lang=js&"
export * from "./warehouseShelves.vue?vue&type=script&lang=js&"
import style0 from "./warehouseShelves.vue?vue&type=style&index=0&id=65cc0f61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cc0f61",
  null
  
)

export default component.exports